// extracted by mini-css-extract-plugin
module.exports = {"container":"DragDropArea_container__1NqWC","infoArea":"DragDropArea_infoArea__2xdUE","infoText":"DragDropArea_infoText__2yf10","infoArrow":"DragDropArea_infoArrow__1js0X"};